module.exports = __webpack_public_path__ + "img/planta.de572f0b.svg";